import useWindowDimensions from "./use-window-dimensions";

const GRID_BREAKPOINTS = { desktop: 1024, medium: 660 };

const getColCount = (width) => {
    if (width > GRID_BREAKPOINTS.desktop) return 3;
    if (width >= GRID_BREAKPOINTS.medium) return 2;
    return 1;
};

const useColumnCount = () => {
    const { width } = useWindowDimensions();
    return getColCount(width);
};

export default useColumnCount;
